<template>
  <div :class="{
    'club-logo': true,
    large: large,
    small: small,
    medium: medium,
    tiny: tiny,
    square: square,
    opacity: opacity,
  }">
    <img
      :src="teamLogo"
      :class="['logo-img', { 'is-fallback': isFallback }]"
      @error="onImgError"
    />
  </div>
</template>

<script>
import { toRefs, computed } from 'vue';
export default {
  props: ['team', 'selected', 'large', 'small', 'medium', 'tiny', 'square', 'opacity', 'competitionId', 'competition'],
  setup(props) {
    const { selected } = toRefs(props);
    const isSelected = selected ? computed(() => selected.value === true ) : false;
    return {
      get: _.get,
      isSelected,
    }
  },
  methods: {
    onImgError(e) {
      const placeholder = process.env.VUE_APP_PLACEHOLDER;
      if (e.target.src !== placeholder) { e.target.src = placeholder; e.target.classList.add('is-fallback'); }
    },
  },
  computed: {
    clubPlaceholder() {
      return process.env.VUE_APP_PLACEHOLDER;
    },
    isFallback() {
      return this.teamLogo === this.clubPlaceholder;
    },
    teamLogo() {
      const metaImgUrl = _.get(
        this.team,
        'meta.imgUrl',
        ''
      );
      const imgUrl = _.get(
        this.team,
        'imgUrl',
        ''
      );
      const competitionLogo = _.get(
        this.competition,
        'meta.imgUrl',
        ''
      );
      const teamLogo = metaImgUrl === '' ? imgUrl : metaImgUrl;

      // Priority: team logo -> competition logo -> placeholder
      if (teamLogo && teamLogo !== '') {
        return teamLogo;
      }
      if (competitionLogo && competitionLogo !== '') {
        return competitionLogo;
      }
      return this.clubPlaceholder;
    }
  },
};
</script>

<style scoped lang="scss">
.logo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;

  &.is-fallback {
    object-fit: contain;
    padding: 12%;
    box-sizing: border-box;
  }
}

.club-logo {
  width: 4.25rem;
  height: 4.25rem;
  // border: 2px solid rgba(226, 9, 9, 0.1);
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  transition: all 0.1s ease-in-out;

  &.opacity {
    padding: 1rem;
    background: #1c1c1c57;
    border-radius: 200px;

    img {
      border-radius: 200px;
    }
  }

  &.square {
    border-radius: 1rem;
  }

  &.large {
    width: 6.25rem;
    height: 6.25rem;
  }

  &.medium {
    width: 3.25rem !important;
    height: 3.25rem !important;
  }

  &.small {
    width: 2.25rem;
    height: 2.25rem;
  }

  &.tiny {
    width: 1.25rem !important;
    height: 1.25rem !important;
  }
}

.selected-team-logo {
  // border: 2px solid rgb(234, 68, 68, 0.7);
  border: 2px solid rgba($secondary, .5);
  transform: scale(1.05);
  animation: at-ripple-pink 2s linear infinite;
}

.box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120%;
  height: 120%;
  display: flex;
  justify-content: center;
  align-items: center;
}

@-webkit-keyframes at-ripple-pink {
  0% {
    box-shadow: 0 4px 10px rgba($highlight, 0.15), 0 0 0 0 rgba($highlight, 0.15), 0 0 0 5px rgba($highlight, 0.15), 0 0 0 10px rgba($highlight, 0.15);
    -webkit-box-shadow: 0 4px 10px rgba($highlight, 0.15), 0 0 0 0 rgba($highlight, 0.15), 0 0 0 5px rgba($highlight, 0.15), 0 0 0 10px rgba($highlight, 0.15);
  }
  100% {
    box-shadow: 0 4px 10px rgba($highlight, 0.15), 0 0 0 5px rgba($highlight, 0.15), 0 0 0 10px rgba($highlight, 0.15), 0 0 0 20px rgba($highlight, 0);
    -webkit-box-shadow: 0 4px 10px rgba($highlight, 0.15), 0 0 0 5px rgba($highlight, 0.15), 0 0 0 10px rgba($highlight, 0.15), 0 0 0 20px rgba($highlight, 0);
  }
}

@keyframes at-ripple-pink {
  0% {
    box-shadow: 0 4px 10px rgba($highlight, 0.15), 0 0 0 0 rgba($highlight, 0.15), 0 0 0 5px rgba($highlight, 0.15), 0 0 0 10px rgba($highlight, 0.15);
  }
  100% {
    box-shadow: 0 4px 10px rgba($highlight, 0.15), 0 0 0 5px rgba($highlight, 0.15), 0 0 0 10px rgba($highlight, 0.15), 0 0 0 20px rgba($highlight, 0);
    -webkit-box-shadow: 0 4px 10px rgba($highlight, 0.15), 0 0 0 5px rgba($highlight, 0.15), 0 0 0 10px rgba($highlight, 0.15), 0 0 0 20px rgba($highlight, 0);
  }
}



</style>